module.exports = __webpack_public_path__ + "static/media/IconTemplates_-88.21f178fd.svg";